import { invokeApig } from './awsLib'

export default class Cache {
	constructor(AuthUser) {
		this.AuthUser = AuthUser

		this.MY_TEAM_ENTITIES_KEY = 'my-team-entities'
		this.DENIAL_REASONS_KEY = 'denial-reasons'
		this.ROOT_CAUSES_KEY = 'root-causes'
		this.DENIAL_TRACKING_STATUS_KEY = 'denial-tracking-status-key'
		this.DENIAL_TYPES_KEY = 'denial-types-key'
		this.TEAMMATES_KEY = 'teammates-key'

		this.ACCOUNT_STATUSES_KEY = 'account-statuses-key'
		this.DENIAL_APPEAL_STATUSES_KEY = 'denial-appeal-statuses-key'
		this.APPEAL_NOT_SUPPORTED_REASONS_KEY = 'appeal-not-supported-reasons-key'
		this.APPEAL_INFORMATION_ITEMS_KEY = 'appeal-information-items-key'
		this.APPEAL_ACTIONS_KEY = 'appeal-actions-key'
		this.APPEAL_LEVELS_KEY = 'appeal-levels-key'
		this.APPEAL_OUTCOMES_KEY = 'appeal-outcomes-key'

		this.REVIEW_TYPES_KEY = 'review-types'
		this.LEVELS_OF_CARE_KEY = 'review-levels-of-care'
		this.REVIEW_FINDINGS_KEY = 'review-findings'
		this.PHYSICIAN_RESPONSES_KEY = 'physician-responses'
		this.ESCALATION_REASONS_KEY = 'escalation-reasons'
		this.P2P_OUTCOMES_KEY = 'peer-to-peer-outcomes'
		this.P2P_ACTIONS_KEY = 'peer-to-peer-actions'
		this.RISK_CATEGORIES_KEY = 'risk-categories'
		this.STATUS_INDICATORS_KEY = 'status-indicators'
	}

	clear() {
		sessionStorage.removeItem(this.MY_TEAM_ENTITIES_KEY)
		sessionStorage.removeItem(this.DENIAL_REASONS_KEY)
		sessionStorage.removeItem(this.ROOT_CAUSES_KEY)
		sessionStorage.removeItem(this.DENIAL_TRACKING_STATUS_KEY)
		sessionStorage.removeItem(this.DENIAL_TYPES_KEY)
		sessionStorage.removeItem(this.TEAMMATES_KEY)
		sessionStorage.removeItem(this.ACCOUNT_STATUSES_KEY)
		sessionStorage.removeItem(this.DENIAL_APPEAL_STATUSES_KEY)
		sessionStorage.removeItem(this.APPEAL_NOT_SUPPORTED_REASONS_KEY)
		sessionStorage.removeItem(this.APPEAL_INFORMATION_ITEMS_KEY)
		sessionStorage.removeItem(this.APPEAL_ACTIONS_KEY)
		sessionStorage.removeItem(this.APPEAL_LEVELS_KEY)
		sessionStorage.removeItem(this.APPEAL_OUTCOMES_KEY)
		sessionStorage.removeItem(this.REVIEW_TYPES_KEY)
		sessionStorage.removeItem(this.LEVELS_OF_CARE_KEY)
		sessionStorage.removeItem(this.REVIEW_FINDINGS_KEY)
		sessionStorage.removeItem(this.PHYSICIAN_RESPONSES_KEY)
		sessionStorage.removeItem(this.ESCALATION_REASONS_KEY)
		sessionStorage.removeItem(this.P2P_OUTCOMES_KEY)
		sessionStorage.removeItem(this.P2P_ACTIONS_KEY)
		sessionStorage.removeItem(this.RISK_CATEGORIES_KEY)
		sessionStorage.removeItem(this.STATUS_INDICATORS_KEY)
	}

	async LoadAll() {
		await Promise.all([
			this.getTeamEntities(),
			this.getTeammates(),
			this.getAll()
		])
	}

	async getAll() {
		const idToken = await this.AuthUser.get_id_token()
		const result = await invokeApig({ path: `/types/all` }, idToken)

		sessionStorage.setItem(this.REVIEW_TYPES_KEY, JSON.stringify(result.review_types))
		sessionStorage.setItem(this.LEVELS_OF_CARE_KEY, JSON.stringify(result.levels_of_care))
		sessionStorage.setItem(this.REVIEW_FINDINGS_KEY, JSON.stringify(result.review_findings))
		sessionStorage.setItem(this.PHYSICIAN_RESPONSES_KEY, JSON.stringify(result.physician_responses))
		sessionStorage.setItem(this.ESCALATION_REASONS_KEY, JSON.stringify(result.escalation_reasons))
		sessionStorage.setItem(this.P2P_ACTIONS_KEY, JSON.stringify(result.peer_to_peer_actions))
		sessionStorage.setItem(this.P2P_OUTCOMES_KEY, JSON.stringify(result.peer_to_peer_outcomes))
		sessionStorage.setItem(this.RISK_CATEGORIES_KEY, JSON.stringify(result.risk_categories))
		sessionStorage.setItem(this.STATUS_INDICATORS_KEY, JSON.stringify(result.status_indicators))
		sessionStorage.setItem(this.DENIAL_REASONS_KEY, JSON.stringify(result.denial_reasons))
		sessionStorage.setItem(this.ROOT_CAUSES_KEY, JSON.stringify(result.denial_root_causes))
		sessionStorage.setItem(this.DENIAL_TRACKING_STATUS_KEY, JSON.stringify(result.denial_tracking_statuses))
		sessionStorage.setItem(this.DENIAL_TYPES_KEY, JSON.stringify(result.denial_types))
		sessionStorage.setItem(this.ACCOUNT_STATUSES_KEY, JSON.stringify(result.account_statuses))
		sessionStorage.setItem(this.DENIAL_APPEAL_STATUSES_KEY, JSON.stringify(result.denial_appeal_statuses))
		sessionStorage.setItem(this.APPEAL_NOT_SUPPORTED_REASONS_KEY, JSON.stringify(result.appeal_not_supported_reasons))
		sessionStorage.setItem(this.APPEAL_INFORMATION_ITEMS_KEY, JSON.stringify(result.appeal_information_items))
		sessionStorage.setItem(this.APPEAL_ACTIONS_KEY, JSON.stringify(result.appeal_actions))
		sessionStorage.setItem(this.APPEAL_LEVELS_KEY, JSON.stringify(result.appeal_levels))
		sessionStorage.setItem(this.APPEAL_OUTCOMES_KEY, JSON.stringify(result.appeal_outcomes))

		return result
	}

	async getTeamEntities() {
		if (sessionStorage[this.MY_TEAM_ENTITIES_KEY]) {
			return JSON.parse(sessionStorage[this.MY_TEAM_ENTITIES_KEY])
		} else {
			const idToken = await this.AuthUser.get_id_token()
			const result = await invokeApig({ path: `/users/assigned-entities` }, idToken)
			sessionStorage.setItem(this.MY_TEAM_ENTITIES_KEY, JSON.stringify(result.entities))
			return result.entities
		}
	}

	async getDenialReasons() {
		if (sessionStorage[this.DENIAL_REASONS_KEY]) {
			return JSON.parse(sessionStorage[this.DENIAL_REASONS_KEY])
		} else {
			const idToken = await this.AuthUser.get_id_token()
			const result = await invokeApig({ path: `/types/denial-reasons` }, idToken)
			sessionStorage.setItem(this.DENIAL_REASONS_KEY, JSON.stringify(result.types))
			return result.types
		}
	}

	async getRootCauses() {
		if (sessionStorage[this.ROOT_CAUSES_KEY]) {
			return JSON.parse(sessionStorage[this.ROOT_CAUSES_KEY])
		} else {
			const idToken = await this.AuthUser.get_id_token()
			const result = await invokeApig({ path: `/types/denial-root-causes` }, idToken)
			sessionStorage.setItem(this.ROOT_CAUSES_KEY, JSON.stringify(result.types))
			return result.types
		}
	}

	async getDenialTrackingStatuses() {
		if (sessionStorage[this.DENIAL_TRACKING_STATUS_KEY]) {
			return JSON.parse(sessionStorage[this.DENIAL_TRACKING_STATUS_KEY])
		} else {
			const idToken = await this.AuthUser.get_id_token()
			const result = await invokeApig({ path: `/types/denial-tracking-statuses` }, idToken)
			sessionStorage.setItem(this.DENIAL_TRACKING_STATUS_KEY, JSON.stringify(result.types))
			return result.types
		}
	}

	async getDenialTypes() {
		if (sessionStorage[this.DENIAL_TYPES_KEY]) {
			return JSON.parse(sessionStorage[this.DENIAL_TYPES_KEY])
		} else {
			const idToken = await this.AuthUser.get_id_token()
			const result = await invokeApig({ path: `/types/denial-types` }, idToken)
			sessionStorage.setItem(this.DENIAL_TYPES_KEY, JSON.stringify(result.types))
			return result.types
		}
	}

	async getTeammates() {
		if (sessionStorage[this.TEAMMATES_KEY]) {
			return JSON.parse(sessionStorage[this.TEAMMATES_KEY])
		} else {
			const idToken = await this.AuthUser.get_id_token()
			const result = await invokeApig({ path: `/users/teammates` }, idToken)
			sessionStorage.setItem(this.TEAMMATES_KEY, JSON.stringify(result.teammates))
			return result.teammates
		}
	}

	async getAccountStatuses() {
		if (sessionStorage[this.ACCOUNT_STATUSES_KEY]) {
			return JSON.parse(sessionStorage[this.ACCOUNT_STATUSES_KEY])
		} else {
			const idToken = await this.AuthUser.get_id_token()
			const result = await invokeApig({ path: `/types/account-statuses` }, idToken)
			sessionStorage.setItem(this.ACCOUNT_STATUSES_KEY, JSON.stringify(result.types))
			return result.types
		}
	}

	async getDenialAppealStatuses() {
		if (sessionStorage[this.DENIAL_APPEAL_STATUSES_KEY]) {
			return JSON.parse(sessionStorage[this.DENIAL_APPEAL_STATUSES_KEY])
		} else {
			const idToken = await this.AuthUser.get_id_token()
			const result = await invokeApig({ path: `/types/denial-appeal-statuses` }, idToken)
			sessionStorage.setItem(this.DENIAL_APPEAL_STATUSES_KEY, JSON.stringify(result.types))
			return result.types
		}
	}

	async getAppealNotSupportedReasons() {
		if (sessionStorage[this.APPEAL_NOT_SUPPORTED_REASONS_KEY]) {
			return JSON.parse(sessionStorage[this.APPEAL_NOT_SUPPORTED_REASONS_KEY])
		} else {
			const idToken = await this.AuthUser.get_id_token()
			const result = await invokeApig({ path: `/types/appeal-not-supported-reasons` }, idToken)
			sessionStorage.setItem(this.APPEAL_NOT_SUPPORTED_REASONS_KEY, JSON.stringify(result.types))
			return result.types
		}
	}

	async getAppealInformationItems() {
		if (sessionStorage[this.APPEAL_INFORMATION_ITEMS_KEY]) {
			return JSON.parse(sessionStorage[this.APPEAL_INFORMATION_ITEMS_KEY])
		} else {
			const idToken = await this.AuthUser.get_id_token()
			const result = await invokeApig({ path: `/types/appeal-information-items` }, idToken)
			sessionStorage.setItem(this.APPEAL_INFORMATION_ITEMS_KEY, JSON.stringify(result.types))
			return result.types
		}
	}

	async getAppealActions() {
		if (sessionStorage[this.APPEAL_ACTIONS_KEY]) {
			return JSON.parse(sessionStorage[this.APPEAL_ACTIONS_KEY])
		} else {
			const idToken = await this.AuthUser.get_id_token()
			const result = await invokeApig({ path: `/types/appeal-actions` }, idToken)
			sessionStorage.setItem(this.APPEAL_ACTIONS_KEY, JSON.stringify(result.types))
			return result.types
		}
	}

	async getAppealLevels() {
		if (sessionStorage[this.APPEAL_LEVELS_KEY]) {
			return JSON.parse(sessionStorage[this.APPEAL_LEVELS_KEY])
		} else {
			const idToken = await this.AuthUser.get_id_token()
			const result = await invokeApig({ path: `/types/appeal-levels` }, idToken)
			sessionStorage.setItem(this.APPEAL_LEVELS_KEY, JSON.stringify(result.types))
			return result.types
		}
	}

	async getAppealOutcomes() {
		if (sessionStorage[this.APPEAL_OUTCOMES_KEY]) {
			return JSON.parse(sessionStorage[this.APPEAL_OUTCOMES_KEY])
		} else {
			const idToken = await this.AuthUser.get_id_token()
			const result = await invokeApig({ path: `/types/appeal-outcomes` }, idToken)
			sessionStorage.setItem(this.APPEAL_OUTCOMES_KEY, JSON.stringify(result.types))
			return result.types
		}
	}

	async getReviewTypes() {
		if (sessionStorage[this.REVIEW_TYPES_KEY]) {
			return JSON.parse(sessionStorage[this.REVIEW_TYPES_KEY])
		} else {
			const idToken = await this.AuthUser.get_id_token()
			const result = await invokeApig({ path: `/types/review-types` }, idToken)
			sessionStorage.setItem(this.REVIEW_TYPES_KEY, JSON.stringify(result.types))
			return result.types
		}
	}

	async getLevelsOfCare() {
		if (sessionStorage[this.LEVELS_OF_CARE_KEY]) {
			return JSON.parse(sessionStorage[this.LEVELS_OF_CARE_KEY])
		} else {
			const idToken = await this.AuthUser.get_id_token()
			const result = await invokeApig({ path: `/types/review-levels-of-care` }, idToken)
			sessionStorage.setItem(this.LEVELS_OF_CARE_KEY, JSON.stringify(result.types))
			return result.types
		}
	}

	async getReviewFindings() {
		if (sessionStorage[this.REVIEW_FINDINGS_KEY]) {
			return JSON.parse(sessionStorage[this.REVIEW_FINDINGS_KEY])
		} else {
			const idToken = await this.AuthUser.get_id_token()
			const result = await invokeApig({ path: `/types/review-findings` }, idToken)
			sessionStorage.setItem(this.REVIEW_FINDINGS_KEY, JSON.stringify(result.types))
			return result.types
		}
	}

	async getPhysicianResponses() {
		if (sessionStorage[this.PHYSICIAN_RESPONSES_KEY]) {
			return JSON.parse(sessionStorage[this.PHYSICIAN_RESPONSES_KEY])
		} else {
			const idToken = await this.AuthUser.get_id_token()
			const result = await invokeApig({ path: `/types/physician-responses` }, idToken)
			sessionStorage.setItem(this.PHYSICIAN_RESPONSES_KEY, JSON.stringify(result.types))
			return result.types
		}
	}

	async getEscalationReasons() {
		if (sessionStorage[this.ESCALATION_REASONS_KEY]) {
			return JSON.parse(sessionStorage[this.ESCALATION_REASONS_KEY])
		} else {
			const idToken = await this.AuthUser.get_id_token()
			const result = await invokeApig({ path: `/types/escalation-reasons` }, idToken)
			sessionStorage.setItem(this.ESCALATION_REASONS_KEY, JSON.stringify(result.types))
			return result.types
		}
	}

	async getPeerToPeerOutcomes() {
		if (sessionStorage[this.P2P_OUTCOMES_KEY]) {
			return JSON.parse(sessionStorage[this.P2P_OUTCOMES_KEY])
		} else {
			const idToken = await this.AuthUser.get_id_token()
			const result = await invokeApig({ path: `/types/peer-to-peer-outcomes` }, idToken)
			sessionStorage.setItem(this.P2P_OUTCOMES_KEY, JSON.stringify(result.types))
			return result.types
		}
	}

	async getPeerToPeerActions() {
		if (sessionStorage[this.P2P_ACTIONS_KEY]) {
			return JSON.parse(sessionStorage[this.P2P_ACTIONS_KEY])
		} else {
			const idToken = await this.AuthUser.get_id_token()
			const result = await invokeApig({ path: `/types/peer-to-peer-actions` }, idToken)
			sessionStorage.setItem(this.P2P_ACTIONS_KEY, JSON.stringify(result.types))
			return result.types
		}
	}

	async getRiskCategories() {
		if (sessionStorage[this.RISK_CATEGORIES_KEY]) {
			return JSON.parse(sessionStorage[this.RISK_CATEGORIES_KEY])
		} else {
			const idToken = await this.AuthUser.get_id_token()
			const result = await invokeApig({ path: `/types/risk-categories` }, idToken)
			sessionStorage.setItem(this.RISK_CATEGORIES_KEY, JSON.stringify(result.types))
			return result.types
		}
	}

	async getStatusIndicators() {
		if (sessionStorage[this.STATUS_INDICATORS_KEY]) {
			return JSON.parse(sessionStorage[this.STATUS_INDICATORS_KEY])
		} else {
			const idToken = await this.AuthUser.get_id_token()
			const result = await invokeApig({ path: `/types/status-indicators` }, idToken)
			sessionStorage.setItem(this.STATUS_INDICATORS_KEY, JSON.stringify(result.types))
			return result.types
		}
	}
}
